// src/components/organism/Users/UsersSuccessModal/UsersSuccessModal.tsx
import React from 'react';
import { Container, Row, Col, Button, IconButton, CopyIcon } from 'shared-portal-component';

import AppModal from '@/components/common/AppModal/AppModal';
import { PORTAL_URL } from '@/config/apiConfig';

interface UsersSuccessModalProps {
  open: boolean;
  onClose: () => void;
  invitationLink: string;
  otp: string;
}

const UsersSuccessModal: React.FC<UsersSuccessModalProps> = ({
  open,
  onClose,
  invitationLink,
  otp,
}) => {
  if (!open) return null;

  const url = `${PORTAL_URL}/registration`;
  const copyToClipboard = async(text: string): Promise<void> => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.body.removeChild(textarea);
    }
  };

  return (
    <AppModal
      onClose={onClose}
      title="Invitation Details"
      aria-label="User invitation details"
      size="md"
    >
      <Container fluid>
        {/* Descriptive text from the simple modal */}
        <Row spacing="none">
          <Col>
            <p className="text-left">
              Your new user has been sent an email with information they need to configure and start
              using their PortalSIX account.
            </p>
            <p className="mt-3 text-left">
              Once they configure their account, their status will change from New to Active.
            </p>
          </Col>
        </Row>

        <Row spacing="md" justify="center" className="mt-6">
          <Col size={12} className="text-center">
            {/* Invitation Link */}
            <div className="mb-6">
              <div className="font-semibold mb-2">Invitation Link</div>
              <div className="flex items-center justify-center gap-2">
                <span style={{ wordBreak: 'break-all' }}>
                  {url}
                </span>
                <IconButton
                  icon={<CopyIcon size="sm" />}
                  variant="secondary"
                  size="sm"
                  ariaLabel="Copy invitation link"
                  onClick={() => {
                    void copyToClipboard(url);
                  }}
                />
              </div>
            </div>

            {/* OTP */}
            <div className="mb-6">
              <div className="font-semibold mb-2">One-Time Passcode (OTP)</div>
              <div className="flex items-center justify-center gap-2">
                <span>{otp}</span>
                <IconButton
                  icon={<CopyIcon size="sm" />}
                  variant="secondary"
                  size="sm"
                  ariaLabel="Copy OTP"
                  onClick={() => {
                    void copyToClipboard(otp);
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>

        {/* Close button */}
        <Row spacing="none" justify="center" className="mt-6">
          <Col size="content">
            <Button
              onClick={onClose}
              variant="primary"
              text="Close"
              aria-label="Close invitation modal"
            />
          </Col>
        </Row>
      </Container>
    </AppModal>
  );
};

export default UsersSuccessModal;
